<template>
  <div class="content" :style="{'backgroundImage': 'url(' + themeList[theme].backgroundImg + ')'}">
    <div class="login" v-if="!isEnd">

      <div v-if="!loginModel" :class="!theme ? 'innovative' : 'criticize'">
        <img
          :src="themeList[theme].headerLogo"
          class="title"
          alt=""
        />
        <div class="schoolClass list">
          <!-- <el-select v-model="county" placeholder="请选择县（区）">
            <el-option
              v-for="(item, index) in countyList"
              :key="item.province_id"
              :label="item.province_name"
              :value="index"
            >
            </el-option>
          </el-select>-->
          <el-cascader
            class="school"
            :options="countyList"
            v-model="county"
            placeholder="请选择县（区）"
            @change="handleChange">
            <template #suffixIcon>
              <img src="@/assets/exam/theme0/arrow.png" class="custom-arrow-icon" />
            </template>
          </el-cascader>
          <el-select v-model="school" placeholder="请选择学校">
              <template v-for="(item, index) in schoolList">
                <el-option
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                  v-if="item.show"
                >
                </el-option>
              </template>
          </el-select>
        </div>
        <div class="schoolClass list">
          <el-select v-model="grade" class="school" placeholder="请选择年级">
            <el-option el-option
              v-for="(item, index) in gradeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-select v-model="classId" placeholder="请选择班级">
            <el-option el-option
              v-for="(item, index) in classList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="formName">
          <el-input
            class="inputElement list"
            :style="errText ? 'border: 1px solid #ED724F':''"
            v-model="name"
            @focus="errText = ''"
            placeholder="请输入姓名"
          ></el-input>
          <span class="errText" v-if="errText">{{errText}}</span>
        </div>
        <div class="schoolClass  list">
          <el-input
            class="school"
            v-model="num"
            placeholder="请输入报名号"
          ></el-input>
          <el-select v-model="gender" class="class" placeholder="请选择性别">
            <el-option el-option
              label="女"
              value="1"
            >
            </el-option>
            <el-option el-option
              label="男"
              value="2"
            >
            </el-option>
          </el-select>
        </div>
        <div class="submit" @click="go" :style="{'backgroundImage': 'url(' + themeList[theme].submit_btn_bg + ')'}"></div>
      </div>
      <div v-if="loginModel">
        <div class="created" :style="{'backgroundImage': 'url(' + themeList[theme].created_bg + ')'}">
          <img :src="themeList[theme].complete_logo" class="created_logo" alt="created_logo" />
          <p>同学们好! </p>
          <p>{{ theme ? '接下来你将完成3个任务，每个任务由若干小题组成。' : '接下来你将完成3个任务，每个任务由6个小题组成。' }}</p>
          <p>{{ theme ? '总计作答时间为90分钟，请注意时间进度提示。' : '任务作答时间总计为90分钟。其中的每个小题各有时间限制，请注意作答区的时间进度提示。' }}</p>
          <p v-if="!theme">每个小题作答完成并点击“下一题”后不能返回修改。</p>
          <p>观看任务中视频材料时请戴好耳机。</p>
          <p>请点击下方按钮开始作答。</p>
          <img class="submit created_btn" @click="beginExam" :src="themeList[theme].created_btn" alt="created_btn" />
        </div>
      </div>
    </div>
    <div class="login" v-else>
      <div class="complete" :style="{'backgroundImage': 'url(' + themeList[theme].complete_bg + ')'}">
        <img :src="themeList[theme].complete_logo" class="complete_logo" alt="complete_logo" />
        <img :src="themeList[theme].complete_content" class="complete_content" alt="complete_content" />
        <img :src="themeList[theme].complete_btn" class="complete_btn" alt="complete_btn" />
      </div>
    </div>
    <div class="tag">北京格如灵科技有限公司 提供在线支持</div>
    <Maintain :subjectGroup="urlId" desc="未到答题时间，请在规定时间内进行登录"></Maintain>
  </div>
</template>

<script>
import { UAParser } from 'ua-parser-js';
import { loginContent, login, submitTime, statsLogin } from '@/services/exam'
import { postResultStats } from '@/utils/stats'
import Maintain from '@/component/maintain.vue';

export default {
  components: {
    Maintain
  },
  data() {
    return {
      class: '',
      county: '',
      school: '',
      grade: '',
      classId: '',
      name: '',
      num: '',
      gender: '',
      errText: '',
      schoolList: [],
      gradeList: [],
      countyList: [],
      classList: [],
      theme: 0,
      loginSuccess: false,
      themeList: [
        {
          backgroundImg: require('@/assets/exam/theme0/login_bg.png'),
          headerLogo: require('@/assets/exam/theme0/logo.png'),
          text_bg: require('@/assets/exam/theme0/wancheng_bg.png'),
          submit_btn_bg: require('@/assets/exam/theme0/submit_btn_bg.png'),
          '--color': '#518464',
          // 开始作答
          created_bg: require('@/assets/exam/theme0/bj_tx@2x.png'),
          created_logo: require('@/assets/exam/theme0/complete_logo.png'),
          created_btn: require('@/assets/exam/theme0/button_zd@2x.png'),
          // 答题完成
          complete_bg: require('@/assets/exam/theme0/complete_bg.png'),
          complete_logo: require('@/assets/exam/theme0/complete_logo.png'),
          complete_content: require('@/assets/exam/theme0/complete_content.png'),
          complete_btn: require('@/assets/exam/theme0/complete_btn.png'),
        },
        {
          backgroundImg: require('@/assets/exam/theme1/login_bg.png'),
          headerLogo: require('@/assets/exam/theme1/logo.png'),
          text_bg: require('@/assets/exam/theme1/wancheng_bg.png'),
          submit_btn_bg: require('@/assets/exam/theme1/submit_btn_bg.png'),
          '--color': '#5e2e56',
          // 开始作答
          created_bg: require('@/assets/exam/theme1/bj_tx@2x.png'),
          created_logo: require('@/assets/exam/theme1/complete_logo.png'),
          created_btn: require('@/assets/exam/theme1/button_zd@2x.png'),
          // 答题完成
          complete_bg: require('@/assets/exam/theme1/complete_bg.png'),
          complete_logo: require('@/assets/exam/theme1/complete_logo.png'),
          complete_content: require('@/assets/exam/theme1/complete_content.png'),
          complete_btn: require('@/assets/exam/theme1/complete_btn.png'),
        }
      ]
    };
  },
  computed: {
    isEnd() {
      return this.$route.query.isEnd
    },
    loginModel() {
      return this.loginSuccess && this.$route.query.time === 'pm'
    }
  },
  created() {
    const subject = this.$route.query.subject || 'pepper'
    sessionStorage.setItem('subjectName', subject)
    this.subject = subject
    if ('teacher_innovationSteer_controller_stormwater_cosmodom_birdFlu_sprout'.indexOf(subject) > -1) {
      this.theme = 0
    } else {
      this.theme = 1
    }
    this.type = this.$route.query.type
    this.timeRoute = this.$route.query.time
    console.log(this.theme)
    // baiduDom.setAttribute('style', 'font-size: 60px !important')
    this.getData()
    // this.initExamGroup()

    if (this.isEnd) {
      postResultStats()
    } else {
      if (!this.checkUrl()) {
        this.$message.info('网址有误，请核对网址')
      }
      this.urlId = this.getExamIdAndTime().urlId
    }
    this.initTheme()
  },
  methods: {
    // 初始化试卷组
    // initExamGroup() {
    //   this.examGroupList = [
    //     {
    //       id: 1,
    //       name: '批判-早上：练习+A',
    //       exam: ['examCriticismSteer', 'examPhone', 'questionCriticism'],
    //       firstExam: 'examPhone'
    //     },
    //     {
    //       id: 2,
    //       name: '批判-下午-初中：B+C',
    //       exam: ['examPepper', 'questionCriticism', 'examDuJiangYan', 'questionCriticism'],
    //       firstExam: 'examPepper'
    //     },
    //     {
    //       id: 3,
    //       name: '批判-下午-初中：C+B',
    //       exam: ['examDuJiangYan', 'questionCriticism', 'examPepper', 'questionCriticism'],
    //       firstExam: 'examDuJiangYan'
    //     },
    //     {
    //       id: 4,
    //       name: '批判-下午-小学：D+E',
    //       exam: ['examChiliProblem', 'questionCriticism', 'examEnergy', 'questionCriticism'],
    //       firstExam: 'examChiliProblem'
    //     },
    //     {
    //       id: 5,
    //       name: '批判-下午-小学：E+D',
    //       exam: ['examEnergy', 'questionCriticism', 'examChiliProblem', 'questionCriticism'],
    //       firstExam: 'examEnergy'
    //     },
    //     {
    //       id: 6,
    //       name: '创新-上午：练习+问卷',
    //       exam: ['examInnovationSteer', 'questionnaireStudent'],
    //       firstExam: ''
    //     },
    //     {
    //       id: 7,
    //       name: '创新-初中-下午：A+B+C',
    //       exam: ['examCosmodom', 'examBirdFlu', 'examController', 'juniorInnovation'],
    //       firstExam: 'examCosmodom'
    //     },
    //     {
    //       id: 8,
    //       name: '创新-初中-下午：B+C+A',
    //       exam: ['examBirdFlu', 'examController', 'examCosmodom', 'juniorInnovation'],
    //       firstExam: 'examBirdFlu'
    //     },
    //     {
    //       id: 9,
    //       name: '创新-初中-下午：C+A+B',
    //       exam: ['examController', 'examCosmodom', 'examBirdFlu', 'juniorInnovation'],
    //       firstExam: 'examController'
    //     },
    //     {
    //       id: 10,
    //       name: '创新-小学-下午：C+D+E',
    //       exam: ['examController', 'examStormwater', 'examSprout', 'elementaryInnovation'],
    //       firstExam: 'examController'
    //     },
    //     {
    //       id: 11,
    //       name: '创新-小学-下午：D+E+C',
    //       exam: ['examStormwater', 'examSprout', 'examController', 'elementaryInnovation'],
    //       firstExam: 'examStormwater'
    //     },
    //     {
    //       id: 12,
    //       name: '创新-小学-下午：E+C+D',
    //       exam: ['examSprout', 'examController', 'examStormwater', 'elementaryInnovation'],
    //       firstExam: 'examController'
    //     },
    //     {
    //       id: 13,
    //       name: '创新-练习-公用',
    //       exam: ['examInnovationSteer'],
    //       firstExam: ''
    //     },
    //     {
    //       id: 14,
    //       name: '批判-练习-公用',
    //       exam: ['examCriticismSteer'],
    //       firstExam: ''
    //     },
    //   ]
    // },
    getData() {
      loginContent().then(res => {
        res.data.school_map.forEach(item => {
          item.show = true
        })
        this.schoolList = res.data.school_map
        this.gradeList = res.data.grade_map
        this.classList = res.data.class_map
        res.data.area_map.forEach(item1 => {
          item1.label = item1.province_name
          item1.value = item1.province_id
          if (!item1.children) return
          item1.children.forEach(item2 => {
            item2.label = item2.city_name
            item2.value = item2.city_id
            if (!item2.children) return
            item2.children.forEach(item3 => {
              item3.label = item3.county_name
              item3.value = item3.county_id
            })
          })
        });
        this.countyList = res.data.area_map
      })
    },
    handleChange() {
      this.school = ''
      this.schoolList.forEach(item => {
        if (item.province_id == this.county[0] && item.city_id == this.county[1] && item.county_id == (this.county[2] || 0)) {
          item.show = true
        } else {
          item.show = false
        }
      })
    },
    // 获取当前浏览器信息
    getExplorerInfo() {
      let explorer = window.navigator.userAgent
      const { browser } = UAParser(explorer)
      const browserName = {
        IE: 'IE',
        Edge: 'Edge',
        other: '其它',
        Chrome: '谷歌浏览器',
        Firefox: '火狐浏览器',
        QQBrowser: 'QQ浏览器'
      }
      return Object.keys(browserName).indexOf(browser.name) > -1 ? browserName[browser.name] : browserName.other
    },
    go() {
      if (!this.checkUrl()) {
        this.$message.info('网址有误，请核对网址')
        return
      }
      let { urlId, allTime } = this.getExamIdAndTime()
      console.log(this.getExplorerInfo())
      const examSubjectMap = [
        {
          id: 1,
          subjectId: 1,
          examUrlName: 'examCosmodom'
        },
        {
          id: 2,
          subjectId: 2,
          examUrlName: 'examBirdFlu'
        },
        {
          id: 3,
          subjectId: 3,
          examUrlName: 'examController'
        },
        {
          id: 4,
          subjectId: 4,
          examUrlName: 'examStormwater'
        },
        {
          id: 5,
          subjectId: 5,
          examUrlName: 'examSprout'
        },
        {
          id: 6,
          subjectId: 6,
          examUrlName: 'examPhone'
        },
        {
          id: 7,
          subjectId: 7,
          examUrlName: 'examPepper'
        },
        {
          id: 8,
          subjectId: 8,
          examUrlName: 'examDuJiangYan'
        },
        {
          id: 9,
          subjectId: 9,
          examUrlName: 'examChiliProblem'
        },
        {
          id: 10,
          subjectId: 10,
          examUrlName: 'examEnergy'
        },
        {
          id: 11,
          subjectId: 11,
          examUrlName: 'examInnovationSteer',
          name: '创新引导'
        },
        {
          id: 12,
          subjectId: 12,
          examUrlName: 'examCriticismSteer',
          name: '批判引导'
        },
        {
          id: 13,
          subjectId: 13,
          examUrlName: 'questionnaireStudent',
          name: '学生问卷/学生人格调查'
        },
        {
          id: 14,
          subjectId: 14,
          examUrlName: 'questionnaireTeacher',
          name: '教师问卷/教师人格调查'
        },
        {
          id: 15,
          subjectId: 15,
          examUrlName: 'questionCriticism',
          name: '批判问卷调查'
        },
        {
          id: 16,
          subjectId: 16,
          examUrlName: 'elementaryInnovation',
          name: '创新问卷调查-小学'
        },
        {
          id: 17,
          subjectId: 17,
          examUrlName: 'juniorInnovation',
          name: '创新问卷调查-初中'
        },
      ]
      sessionStorage.urlId = urlId
      let data = {
        province_id: this.county[0],
        city_id: this.county[1],
        county_id: this.county[2] || 0,
        school_id: this.school,
        class_id: this.classId,
        gender: this.gender,
        grade_id: this.grade,
        stu_name: this.name,
        stu_num: this.num,
        subject_group: urlId
      }
      if (this.$route.query.mock === '54') { // mock
        data = {
          province_id: 1,
          city_id: 8,
          school_id: 15,
          class_id: 38,
          gender: 2,
          grade_id: 1,
          stu_name: 54,
          stu_num: 54,
          subject_group: urlId
        }
      }
      login(data).then(res => {
        if (res.code !== 200) {
          this.errText = '名字不存在'
          this.$message(res.msg)
          return
        }
        sessionStorage.token = res.data.token
        const userData = res.data.user[0]
        sessionStorage.userInfo = JSON.stringify(userData)
        this.loginData = res.data

        // 登陆成功发送统计数据
        statsLogin({
          browser: this.getExplorerInfo(),
          province_id: userData.province_id,
          city_id: userData.city_id,
          county_id: userData.county_id,
          school_id: userData.school_id,
          school_name: userData.school_name,
          grade_id: userData.grade_id,
          class_id: userData.class_id,
          stu_num: userData.stu_num,
          stu_name: userData.stu_name
        }, this.$route.query)

        let currentExamGroup
        // 创新、早上、小学、id
        // if (this.theme == 0 && this.$route.query.type == 'public') {
        //   currentExamGroupIndex = 12
        // } else if (this.theme == 0 && this.$route.query.time !== 'pm') {
        //   currentExamGroupIndex = 5
        // } else if (this.theme == 0 && this.$route.query.time == 'pm' && res.data.user[0].grade_id >= 7 && res.data.user[0].id % 3 === 0) {
        //   currentExamGroupIndex = 6 // 初中
        // } else if (this.theme == 0 && this.$route.query.time == 'pm' && res.data.user[0].grade_id >= 7 && res.data.user[0].id % 3 === 1) {
        //   currentExamGroupIndex = 7 // 初中
        // } else if (this.theme == 0 && this.$route.query.time == 'pm' && res.data.user[0].grade_id >= 7 && res.data.user[0].id % 3 === 2) {
        //   currentExamGroupIndex = 8 // 初中
        // } else if (this.theme == 0 && this.$route.query.time == 'pm' && res.data.user[0].grade_id < 7 && res.data.user[0].id % 3 === 0) {
        //   currentExamGroupIndex = 9 // 小学
        // } else if (this.theme == 0 && this.$route.query.time == 'pm' && res.data.user[0].grade_id < 7 && res.data.user[0].id % 3 === 1) {
        //   currentExamGroupIndex = 10 // 小学
        // } else if (this.theme == 0 && this.$route.query.time == 'pm' && res.data.user[0].grade_id < 7 && res.data.user[0].id % 3 === 2) {
        //   currentExamGroupIndex = 11 // 小学
        // } else if (this.theme == 1 && this.$route.query.type == 'public') {
        //   currentExamGroupIndex = 13
        // } else if (this.theme == 1 && this.$route.query.time !== 'pm') {
        //   currentExamGroupIndex = 0
        // } else if (this.theme == 1 && this.$route.query.time == 'pm' && res.data.user[0].grade_id >= 7 && res.data.user[0].id % 2 === 0) {
        //   currentExamGroupIndex = 1
        // } else if (this.theme == 1 && this.$route.query.time == 'pm' && res.data.user[0].grade_id >= 7 && res.data.user[0].id % 2 === 1) {
        //   currentExamGroupIndex = 2
        // } else if (this.theme == 1 && this.$route.query.time == 'pm' && res.data.user[0].grade_id < 7 && res.data.user[0].id % 2 === 0) {
        //   currentExamGroupIndex = 3
        // } else if (this.theme == 1 && this.$route.query.time == 'pm' && res.data.user[0].grade_id < 7 && res.data.user[0].id % 2 === 1) {
        //   currentExamGroupIndex = 4
        // }
        // currentExamGroup = this.examGroupList[currentExamGroupIndex]
        // sessionStorage.currentExamIndex = '0'
        // sessionStorage.currentExamGroup = JSON.stringify(currentExamGroup)

        currentExamGroup = {
          name: '',
          exam: res.data.exams_config
        }

        sessionStorage.currentExamGroup = JSON.stringify(currentExamGroup)
        sessionStorage.batch = res.data.batch

        // 还原继续作答时间
        if (res.data.remaining_time === -1) { // 未开始或者已经答完题
          sessionStorage.examTime = new Date().getTime()
          this.time = allTime
        } else {
          sessionStorage.examTime = new Date().getTime() - (allTime - res.data.remaining_time) * 1000 * 60
          this.time = res.data.remaining_time
        }

        // 还原上次做题的题目
        if (res.data.exam.subject_id) { // 存在上次做题的题目
          const subjectId = res.data.exam.subject_id
          const examUrlName = examSubjectMap.find(item => item.subjectId === subjectId).examUrlName
          sessionStorage.currentExamIndex = currentExamGroup.exam.findIndex(item => item === examUrlName)
          if (subjectId <= 5 || subjectId === 11 || subjectId === 12) {
            const front = Number(res.data.exam.exam_num.split('_')[0])
            // const back = Number(res.data.exam.exam_num.split('_')[1]) 2-2 3-1
            sessionStorage.selectedQidSmall = (front - 1) * 2 + 1 // 每个创新题目有两个小题。继续做题从第一个小题开始
          } else if ([13, 14, 15, 16, 17].includes(subjectId)) {
            sessionStorage.selectedQidSmall = res.data.exam.exam_num.split('_')[0] - 1
          } else {
            sessionStorage.selectedQidSmall = res.data.exam.exam_num.split('_')[1]
          }
        } else {
          sessionStorage.currentExamIndex = '0'
          sessionStorage.removeItem('selectedQidSmall')
        }
        this.loginSuccess = true
        if (!this.loginModel) this.beginExam()
        // if (this.theme) {
        //   this.$router.push({
        //     // name: 'examCriticismSteer'
        //     name: 'exam' + this.subject[0].toUpperCase() + this.subject.substr(1)
        //   })
        // } else {
        //   this.$router.push({
        //     // name: 'examInnovationSteer'
        //     name: 'exam' + this.subject[0].toUpperCase() + this.subject.substr(1)
        //   })
        // }
      })
    },
    beginExam() {
      const currentExamGroup = JSON.parse(sessionStorage.currentExamGroup)
      let routeName = currentExamGroup.exam[sessionStorage.currentExamIndex]
      if (!routeName) {
        // 若匹配不到上次的题，直接从第一题开始
        sessionStorage.currentExamIndex = '0'
        sessionStorage.removeItem('selectedQidSmall')
        routeName = currentExamGroup.exam[0]
      }
      this.$router.push({ name: routeName })

      clearInterval(this.timer)
      this.timer = setInterval(() => {
        console.log(String(this.loginData.batch))
        submitTime({
          stu_num: this.loginData.user[0].stu_num,
          batch: String(this.loginData.batch),
          remaining_time: this.time,
          subject_group: sessionStorage.urlId
        }).then(res => { })
        if (this.time !== 0) this.time--
      }, 1000 * 60)
    },
    // 计算试卷id和时间
    getExamIdAndTime() {
      let urlId, allTime
      const urlIdMap = [
        // 创新
        {
          public: {
            id: 3,
            time: 30
          },
          am: {
            id: 1,
            time: 30
          },
          pm: {
            id: 2,
            time: 90
          }
        },
        // 批判
        {
          public: {
            id: 6,
            time: 90
          },
          am: {
            id: 4,
            time: 90
          },
          pm: {
            id: 5,
            time: 90
          }
        }
      ]
      if (this.$route.query.type === 'public') {
        urlId = urlIdMap[this.theme].public.id
        allTime = urlIdMap[this.theme].public.time
      } else if (this.$route.query.subject == 'teacher') {
        urlId = 7
        allTime = 60
      } else if (this.$route.query.time === 'pm') {
        urlId = urlIdMap[this.theme].pm.id
        allTime = urlIdMap[this.theme].pm.time
      } else {
        urlId = urlIdMap[this.theme].am.id
        allTime = urlIdMap[this.theme].am.time
      }
      return { urlId, allTime }
    },
    /**
     * 检测是否是正确的地址。必须得是这六个链接才能进入考试
     * /exam/login?subject=phone&time=pm 批判年级组卷--分小（2套DE） 、中学（2套BC)
       /exam/login?subject=controller 创新练习 + 学生问卷---创新问卷
       /exam/login?subject=controller&time=pm 创新年级组卷--分中（ABC）、小学(CDE)---创新任务
       /exam/login?subject=teacher教师问卷---教师问卷
       /exam/login?subject=criticismSteer&type=public  批判练习
       /exam/login?subject=innovationSteer&type=public 创新练习
     * @returns {boolean} true-正确的地址，false-错误的地址
    */
    checkUrl() {
      const urlConditions = [
        { subject: 'criticismSteer', type: 'public' },
        { subject: 'innovationSteer', type: 'public' },
        { subject: 'teacher' },
        { subject: 'controller' },
        { subject: 'phone', timeRoute: 'pm' }
      ]

      return urlConditions.some(condition => {
        for (const key in condition) {
          if (this[key] !== condition[key]) {
            return false
          }
        }
        return true
      })
    },
    initTheme() {
      this.changeTheme(this.themeList[this.theme])
    },
    changeTheme(theme) {
      for (const key in theme) {
        if (Object.hasOwnProperty.call(theme, key)) {
          const element = theme[key]
          document.documentElement.style.setProperty(key, element)
        }
      }
    },
  }
};
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  height: 100vh;
  background-image: url(http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_624e853b4925a/781805511.png);
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  .login {
    width: 750px;
    height: auto;
    border-radius: 20px;
    position: relative;
    z-index: 2;
    p{
      width: 512px;
      font-size: 18px;
      font-weight: 550;
      margin: 0 auto 20px;
    }
    .text{
      color: #fff;
      margin-top: -180px;
      margin-left: 230px;
      display: inline-block;
      position: absolute;
    }
    >div{
      position: relative;
      .errText{
        right: 20px;
        font-size: 16px;
        margin-top: -35px;
        color:#ED724F;
        position: absolute;
      }
    }
    > img {
      width: 677px;
      display: block;
      margin: 0 auto;
      margin-bottom: 33px;
    }
    .list {
      width: 450px;
      height: 60px;
      margin: 0 auto;
      display: block;
      margin-top: 30px;
    }
    .innovative {
      /deep/ .el-select,
      /deep/ .el-input,
      /deep/ .el-cascader{
        height: 60px;
        display: block;
        background-image: url('~@/assets/exam/theme0/cascader_bg.png');
        background-size: 100% 100%;
        .el-input__icon:before {
            content: '\e790';
        }
        .el-select__caret {
          transform: rotate(0deg);
        }
        .is-reverse {
          transform: rotateZ(180deg)
        }
        input {
          height: 100%;
          font-size: 20px;
          background-color: transparent;
          border: none;
        }
      }
      .formName {
        /deep/ .el-input{
          background-image: url('~@/assets/exam/theme0/cascader_bgx2.png');
        }
      }
    }
    .criticize {
      /deep/ .el-select,
      /deep/ .el-input,
      /deep/ .el-cascader{
        height: 60px;
        display: block;
        background-image: url('~@/assets/exam/theme1/cascader_bg.png');
        background-size: 100% 100%;
        .el-input__icon:before {
            content: '\e790';
        }
        input {
          height: 100%;
          font-size: 16px;
          color: #5e2e56;
          background-color: transparent;
          border: none;
        }
        input::placeholder {
          font-size: 16px;
        }
      }
      .formName {
        /deep/ .el-input{
          background-image: url('~@/assets/exam/theme1/cascader_bgx2.png');
        }
      }
    }
    .schoolClass{
      display: flex;
      .school{
        width: 242px;
        margin-right: 30px;
      }
    }
    .submit {
      width: 470px;
      height: 76px;
      border-radius: 6px;
      margin: 0 auto;
      margin-top: 40px;
      font-size: 18px;
      font-weight: 400;
      color: #ffffff;
      line-height: 70px;
      text-align: center;
      cursor: pointer;
      background-size: 100% 100%;
    }
    .innovative {
      /deep/ .el-select,
      /deep/ .el-input,
      /deep/ .el-cascader {
        input {
          font-size: 16px;
          color: #518464;
        }
        input::placeholder {
          font-size: 16px;
        }

      }
    }
    // 作答完成
    .complete {
      width: 588px;
      height: 351px;
      background-size: 100% 100%;
      margin: 0 auto;
      position: relative;
      .complete_logo {
        width: 258px;
        height: 29px;
        position: absolute;
        left: 44px;
        top: 29px;
      }
      .complete_content {
        width: 333px;
        height: 127px;
        position: absolute;
        left: 128px;
        top: 91px;
      }
      .complete_btn {
        width: 470px;
        height: 83px;
        position: absolute;
        left: 59px;
        top: 242px;
      }
    }
    .created {
      width: 588px;
      height: auto;
      background-size: 100% 100%;
      margin: 0 auto;
      padding: 90px 0px 150px 0px;
      position: relative;
      p {
        font-family: '楷体';
        font-weight: bold;
      }
      .created_logo {
        width: 258px;
        height: 29px;
        position: absolute;
        left: 44px;
        top: 29px;
      }
      .created_btn {
        width: 470px;
        height: 83px;
        position: absolute;
        left: 59px;
        bottom: 30px;
      }
    }
  }
  .tag {
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: calc(25vh - 187px);
    left: 0;
    font-size: 20px;
    font-weight: bold;
    color: #808080;
    line-height: 20px;
  }
}
</style>
<style>
#newBridge {
  display: none !important;
}
.el-select-dropdown__item span {
  font-size: 16px;
  font-weight: 400;
}
.el-select-dropdown__item.selected {
  color: var(--color);
}
.el-cascader-node__label{
  font-size: 16px;
  padding: 10px 30px;
  color: var(--color);
}
.el-cascader-node.is-active {
  color: var(--color)
}
.el-cascader-node.in-active-path {
  color: var(--color)
}
.el-cascader-node{
  padding: 30px 10px;
}
.el-cascader-menu__empty-text{
  font-size: 16px;
}
::-webkit-input-placeholder { font-size: 18px !important; }
::-moz-placeholder { font-size: 18px; } /* firefox 19+ */
:-ms-input-placeholder { font-size: 18px; } /* ie */
input:-moz-placeholder { font-size: 18px; }
</style>
